// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".queryFormClass[data-v-243160f6] {\n  padding: 20px 0;\n}\n.demo-drawer__footer[data-v-243160f6] {\n  text-align: right;\n}", ""]);
// Exports
module.exports = exports;
